export const CLIENT_ENV = import.meta.env.VITE_CLIENT;
export const PYTHON_BACKEND = import.meta.env.VITE_PYTHON_BACKEND_URL;
export const IS_LOCAL = import.meta.env.VITE_LOCAL;
